import { HttpHeaders } from "@angular/common/http";

// export const base_url = "http://localhost:4967/api"; //API Local


 export const base_url = 'https://apieauction.jaipurmcheritage.org/api';//Live


export const Report_base_url =
  "http://oswalapp.centralindia.cloudapp.azure.com/JMCEAuctionReportViewerSourceHeritage";
//JMCEAuctionReportViewerSourceHeritage

//export const base_url_Token = 'http://localhost:49674'
export const httpContenttype = {
  headers: new HttpHeaders({
    "Content-type": "application/json",
  }),
};
